<template>
  <TrainerLayout>
    <section class="my-10 mb-4">
      <div class="mb-4">
        <div class="hidden">
          <label for="tabs" class="sr-only">Select a tab</label>
          <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
          <select
            id="tabs"
            name="tabs"
            class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-green-light focus:border-green-light sm:text-sm rounded-md"
          >
            <option>Explore Music</option>

            <option selected>View Playlist</option>
          </select>
        </div>
        <div class="">
          <div class="flex px-1 justify-between">
            <nav class="border-b border-gray-200 -mb-px flex md:space-x-8 space-x-4" aria-label="Tabs">
              <!-- Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->
              <router-link
                :to="{ name: 'music' }"
                class="border-transparent text-gray-500 hover:text-gray-dark hover:border-green-dark whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
              >
                Explore Music
              </router-link>

              <router-link
                :to="{ name: 'playlist' }"
                class="border-transparent text-gray-500 hover:text-gray-dark hover:border-green-dark whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
              >
                View Playlist
              </router-link>
              <router-link
                :to="{ name: 'favorite' }"
                class="border-green-dark text-gray-dark whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
                :class="{ current: 'border-gray-dark text-gray-dark' }"
              >
                Favorite
              </router-link>
            </nav>
          </div>
        </div>
      </div>
      <section>
        <Modal
          :title="'Selected song'"
          v-model="isPlaylistOpen"
          :classStr="'max-w-lg'"
        >
          <div class="flex items-center mb-4 gap-4">
            <div
              class="h-24 w-30 flex-shrink-0 flex relative justify-center items-center"
            >
              <img
                class="rounded-md"
                :src="songImage"
                alt=""
                @error="defaultImage"
              />
            </div>
            <div class="flex flex-col">
              <span>{{ songName }}</span>
              <span class="text-sm">{{ songArtist }}</span>
            </div>
          </div>
          <hr class="text-gray-400 py-2" />
          <div class="mb-4 h-80 overflow-auto">
          <div class="mb-4 text-xl">Select playlist</div>
            <button
              v-for="(t, index) in trainerPlaylist"
              :key="t.id"
              @click="playlistSong = t.id"
              class="block ring-green-light focus:outline-none focus:ring-1 focus:ring-green-light rounded-lg p-2 ml-1"
              :class="index === trainerPlaylist.length - 1 ? '' : 'mb-3'"
            >
              <div class="flex items-center">
                <div>
                  <img
                    class="inline-block h-16 w-16 rounded-md"
                    :src="t.thumbnail_url"
                    alt=""
                    @error="defaultImage"
                  />
                </div>
                <div class="ml-3 text-left">
                  <p
                    class="text-md font-medium text-gray-700 group-hover:text-gray-900 capitalize"
                  >
                    {{ t.name }}
                  </p>
                  <p
                    class="text-sm font-medium text-gray-500 group-hover:text-gray-700"
                  >
                    {{ String(t.count).trim() }} tracks
                  </p>
                </div>
              </div>
            </button>
          </div>
          <div class="flex items-center text-center justify-end">
            <button
              class="w-full h-10 px-6 py-2 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none hover:bg-green-light"
              @click="onClickPlaylist(playlistSong)"
            >
              Add to Playlist
            </button>
          </div>
        </Modal>
        <div>
          <div class="flex flex-col">
            <div class="overflow-x-auto">
              <div
                class="inline-block min-w-full py-2 align-middle"
              >
                <div
                  class="overflow-hidden shadow ring-1 ring-white ring-opacity-5 md:rounded-lg"
                >
                  <table class="min-w-full divide-y divide-gray-300">
                    <thead class="bg-gray-50">
                      <tr>
                        <th></th>
                        <th
                          scope="col"
                          class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                        >
                          Title
                        </th>
                        <th></th>
                        <th
                          scope="col"
                          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Duration
                        </th>
                        <th
                          scope="col"
                          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Mood
                        </th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody
                      class="divide-y divide-gray-200 bg-white"
                      v-if="songs"
                    >
                      <tr v-for="(d, i) in songs" :key="d.id">
                        <td
                          class="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6"
                        >
                          {{ i + 1 }}.
                        </td>
                        <td
                          class="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6"
                        >
                          <div class="flex items-center">
                            <div
                              class="h-12 w-12 flex-shrink-0 flex relative justify-center items-center"
                              v-if="d.image"
                            >
                              <img
                                class="h-12 w-12 rounded-md"
                                :src="d.image"
                                alt=""
                                @error="defaultImage"
                              />
                              <button
                                class="absolute text-green-dark focus:outline-none hidden play-icon"
                                title="Play"
                                @click="onclickPlay(d && d.id)"
                                :class="`play-${d && d.id}`"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="25.5"
                                  height="25.5"
                                  viewBox="0 0 25.5 25.5"
                                >
                                  <g
                                    id="Icon_feather-play-circle"
                                    data-name="Icon feather-play-circle"
                                    transform="translate(-2.25 -2.25)"
                                  >
                                    <path
                                      id="Path_2385"
                                      data-name="Path 2385"
                                      d="M27,15A12,12,0,1,1,15,3,12,12,0,0,1,27,15Z"
                                      transform="translate(0 0)"
                                      fill="#8dc73f"
                                      stroke="#8dc73f"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="1.5"
                                    />
                                    <path
                                      id="Path_2386"
                                      data-name="Path 2386"
                                      d="M15,12l9,6-9,6Z"
                                      transform="translate(-3.429 -3)"
                                      fill="#fff"
                                      stroke="#fff"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="1.5"
                                    />
                                  </g>
                                </svg>
                              </button>
                              <button
                                class="absolute text-green-dark focus:outline-none hidden pause-icon"
                                title="Pause"
                                @click="onclickPause(d && d.id)"
                                :class="`pause-${d && d.id}`"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="h-8 w-8"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z"
                                    clip-rule="evenodd"
                                  />
                                </svg>
                              </button>
                            </div>
                            <div class="h-12 w-12 flex-shrink-0" v-else>
                              <img
                                class="h-12 w-12 rounded-md"
                                src=""
                                alt=""
                                @error="defaultImage"
                              />
                            </div>
                            <div class="ml-4">
                              <div class="font-semibold text-gray-900">
                                {{ d.name || "Music Name" }}
                              </div>
                              <div class="text-gray-dark">
                                {{ d.artist }}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td
                          class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                        >
                          <button
                            class="focus:outline-none"
                            @click="onclickWaveform(d && d.id)"
                          >
                            <av-waveform
                              :audio-class="`audio-${d && d.id}`"
                              :audio-src="d.url"
                              :canv-width="250"
                              :canv-height="30"
                              :audio-controls="false"
                              :playtime-with-ms="false"
                              :playtime-clickable="true"
                              :played-line-color="'#8dc73f'"
                              :noplayed-line-color="'#B5B5B5'"
                              :playtime-font-color="'#8dc73f'"
                              :playtime-slider-color="'#8dc73f'"
                            >
                            </av-waveform>
                          </button>
                        </td>
                        <td
                          class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                        >
                          <!-- <div class="text-gray-900">Front-end Developer</div> -->
                          <!-- <div class="text-gray-500">Optimization</div> -->
                          {{ formatSecond(d.duration || "0.00" / 60) }}
                        </td>
                        <td
                          class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                        >
                          {{
                            d.mood && d.mood.replace(/["]+/g, "").slice(1, -1)
                          }}
                        </td>
                        <td class="whitespace-nowrap px-3 py-4 text-gray-dark">
                          <button
                            @click="handleFavorite(d)"
                            class="focus:outline-none"
                          >
                            <HeartFill :classStr="'h-8 w-8'" />
                          </button>
                        </td>
                        <td
                          class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                        >
                          <button
                            type="button"
                            title="Add"
                            class="hover:bg-green-light hover:text-white focus:outline-none"
                            @click="
                              onclickAdd(
                                d && d.id,
                                d && d.image,
                                d && d.name,
                                d && d.artist,
                                d && d.url,
                                d && d.mood,
                                d && d.duration
                              )
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-6 w-6 ring-2 ring-green-light rounded-md"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              stroke-width="2"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                              />
                            </svg>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <p>No data found.</p>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mt-8">
          <button
            class="h-8 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light ring-1 ring-green-light rounded-lg focus:outline-none hover:bg-white hover:text-green-light"
            @click="onclickViewmore"
            v-if="
              trainerFavoriteSong &&
              trainerFavoriteSong.data &&
              trainerFavoriteSong.data.next_page_url
            "
          >
            View More
          </button>
        </div>
      </section>
    </section>
  </TrainerLayout>
</template>
<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import { Heart, HeartFill } from "@/components/icons";
import debounce from "debounce";
import { duration } from "moment";
import { mapGetters, mapActions } from "vuex";
import { Modal } from "@/components/t-components";

export default {
  components: {
    TrainerLayout,
    Heart,
    HeartFill,
    Modal,
  },
  data() {
    return {
      songs: [],
      isFavorite: false,
      favoriteArr: [],
      params: 1,
      playlistData: {},
      isPlaylistOpen: false,
      playlistSong: null,
      songName: "",
      songImage: "",
      songArtist: ""
    };
  },
  computed: {
    ...mapGetters(["trainerPlaylist", "trainerFavoriteSong"]),
  },
  methods: {
    ...mapActions([
      "postTrainerPlaylistSong",
      "getTrainerPlaylist",
      "getTrainerFavoriteSong",
      "postTrainerFavoriteSong",
      "postTrainerPlaylistSong",
    ]),
    async handleFavorite(data) {
      this.favoriteArr.push(data);
      const newData = {
        id: 1,
        image: data && data.image,
        url: data && data.url,
        duration: data && data.duration,
        song_id: data && data.song_id,
        name: data && data.name,
        artist: data && data.artist,
        mood: data && data.mood,
        favourite: "yes",
        sort: 0,
      };
      await this.postTrainerFavoriteSong(newData);
      await this.getTrainerFavoriteSong(1);
      this.songs =
        this.trainerFavoriteSong &&
        this.trainerFavoriteSong.data &&
        this.trainerFavoriteSong.data.data;
    },

    getRelationships(result1, result2) {
      var result = result2.filter(function (o1) {
        return (
          result1 &&
          result1.some(function (o2) {
            return o1.id === o2.id; // return the ones with equal id
          })
        );
      });
      return result;
    },

    onclickWaveform(id) {
      var elems = document.getElementsByClassName("play-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var elems = document.getElementsByClassName("pause-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var playIcon = document.getElementsByClassName(`play-${id}`)[0];
      playIcon.style.display = "none";

      var pauseIcon = document.getElementsByClassName(`pause-${id}`)[0];
      pauseIcon.style.display = "block";

      var allAudios = document.querySelectorAll("audio");
      allAudios.forEach(function (audio) {
        audio.pause();
      });
      allAudios.forEach(function (audio) {
        audio.currentTime;
        if (audio.className != `audio-${id}`) {
          audio.load();
          audio.currentTime = 0;
          audio.closest("tr").classList.remove("active");
        } else {
          audio.play();
          audio.closest("tr").classList.add("active");
        }
      });
    },

    onclickPlay(id) {
      var elems = document.getElementsByClassName("play-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var elems = document.getElementsByClassName("pause-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var playIcon = document.getElementsByClassName(`play-${id}`)[0];
      playIcon.style.display = "none";

      var pauseIcon = document.getElementsByClassName(`pause-${id}`)[0];
      pauseIcon.style.display = "block";

      var allAudios = document.querySelectorAll("audio");
      allAudios.forEach(function (audio) {
        audio.pause();
      });
      allAudios.forEach(function (audio) {
        audio.currentTime = 0;
        if (audio.className != `audio-${id}`) {
          audio.load();
          audio.currentTime = 0;
          audio.closest("tr").classList.remove("active");
        } else {
          audio.play();
          audio.closest("tr").classList.add("active");
        }
      });
    },

    onclickPause(id) {
      var elems = document.getElementsByClassName("play-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var elems = document.getElementsByClassName("pause-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var playIcon = document.getElementsByClassName(`play-${id}`)[0];
      playIcon.style.display = "block";

      var pauseIcon = document.getElementsByClassName(`pause-${id}`)[0];
      pauseIcon.style.display = "none";

      var audio = document.getElementsByClassName(`audio-${id}`)[0];
      audio.pause();
    },

    formatSecond(val) {
      var date = new Date(0);
      date.setSeconds(val); // specify value for SECONDS here
      var timeString = date.toISOString().substr(11, 8);
      return timeString;
    },
    onclickAdd(song_id, image, name, artist, url, mood, duration) {
      const data = {
        id: 1,
        image: image,
        url: url,
        duration: duration,
        song_id: song_id,
        name: name,
        artist: artist,
        mood: mood,
        sort: 0,
      };
      (this.songImage = data.image),
        (this.songName = data.name),
        (this.songArtist = data.artist),
      this.playlistData = data;
      this.togglePlaylistModal();
    },

    async onClickPlaylist(id) {
      var data = this.playlistData;
      data.playlist_id = id;
      await this.postTrainerPlaylistSong(data);
      this.getTrainerPlaylist();
      this.togglePlaylistModal();
    },

    togglePlaylistModal() {
      this.isPlaylistOpen = !this.isPlaylistOpen;
    },

    async onclickViewmore() {
      var moreSongs =
        this.trainerFavoriteSong &&
        this.trainerFavoriteSong.data &&
        this.trainerFavoriteSong.data.next_page_url;
      this.params = moreSongs.substring(moreSongs.indexOf("=") + 1);
      await this.getTrainerFavoriteSong(this.params);
      this.trainerFavoriteSong &&
        this.trainerFavoriteSong.data &&
        this.trainerFavoriteSong.data.data.forEach((item) =>
          this.songs.push(item)
        );
    },

    // UpdateEnergyValues(e) {
    // this.energyMinValue = e.minValue;
    // this.energyMaxValue = e.maxValue;
    // },
  },
  async created() {
    await this.getTrainerFavoriteSong(this.params);
    this.songs =
      this.trainerFavoriteSong &&
      this.trainerFavoriteSong.data &&
      this.trainerFavoriteSong.data.data;
  },
};
</script>
<style scoped>
.play-icon {
  display: none;
}
tr:not(.active):hover .play-icon {
  display: inline !important;
}
tr:hover td {
  background: #f5f5f5;
}
</style>
